import { getUrlDataquery } from "./getUrlDataquery.mjs";
const getDataRequestQuery = ({ type, identifiers, dataquery }) => {
  const { agencyId, code, version = "" } = identifiers;
  const dq = getUrlDataquery(dataquery);
  return `${type}/${agencyId},${code},${version}/${dq}`;
};
export {
  getDataRequestQuery
};
